import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/components/ui/select';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useI18n } from '@/contexts/I18nContext';

// Países e função de estados (copiados do SignUpStepTwo)
const countries = [
  { value: 'afghanistan', label: 'Afghanistan' },
  { value: 'albania', label: 'Albania' },
  { value: 'algeria', label: 'Algeria' },
  { value: 'andorra', label: 'Andorra' },
  { value: 'angola', label: 'Angola' },
  { value: 'antigua-and-barbuda', label: 'Antigua and Barbuda' },
  { value: 'argentina', label: 'Argentina' },
  { value: 'armenia', label: 'Armenia' },
  { value: 'australia', label: 'Australia' },
  { value: 'austria', label: 'Austria' },
  { value: 'azerbaijan', label: 'Azerbaijan' },
  { value: 'bahamas', label: 'Bahamas' },
  { value: 'bahrain', label: 'Bahrain' },
  { value: 'bangladesh', label: 'Bangladesh' },
  { value: 'barbados', label: 'Barbados' },
  { value: 'belarus', label: 'Belarus' },
  { value: 'belgium', label: 'Belgium' },
  { value: 'belize', label: 'Belize' },
  { value: 'benin', label: 'Benin' },
  { value: 'bhutan', label: 'Bhutan' },
  { value: 'bolivia', label: 'Bolivia' },
  { value: 'bosnia-and-herzegovina', label: 'Bosnia and Herzegovina' },
  { value: 'botswana', label: 'Botswana' },
  { value: 'brazil', label: 'Brazil' },
  { value: 'brunei', label: 'Brunei' },
  { value: 'bulgaria', label: 'Bulgaria' },
  { value: 'burkina-faso', label: 'Burkina Faso' },
  { value: 'burundi', label: 'Burundi' },
  { value: 'cabo-verde', label: 'Cabo Verde' },
  { value: 'cambodia', label: 'Cambodia' },
  { value: 'cameroon', label: 'Cameroon' },
  { value: 'canada', label: 'Canada' },
  { value: 'central-african-republic', label: 'Central African Republic' },
  { value: 'chad', label: 'Chad' },
  { value: 'chile', label: 'Chile' },
  { value: 'china', label: 'China' },
  { value: 'colombia', label: 'Colombia' },
  { value: 'comoros', label: 'Comoros' },
  { value: 'congo', label: 'Congo' },
  { value: 'costa-rica', label: 'Costa Rica' },
  { value: 'croatia', label: 'Croatia' },
  { value: 'cuba', label: 'Cuba' },
  { value: 'cyprus', label: 'Cyprus' },
  { value: 'czech-republic', label: 'Czech Republic' },
  { value: 'democratic-republic-of-congo', label: 'Democratic Republic of Congo' },
  { value: 'denmark', label: 'Denmark' },
  { value: 'djibouti', label: 'Djibouti' },
  { value: 'dominica', label: 'Dominica' },
  { value: 'dominican-republic', label: 'Dominican Republic' },
  { value: 'ecuador', label: 'Ecuador' },
  { value: 'egypt', label: 'Egypt' },
  { value: 'el-salvador', label: 'El Salvador' },
  { value: 'equatorial-guinea', label: 'Equatorial Guinea' },
  { value: 'eritrea', label: 'Eritrea' },
  { value: 'estonia', label: 'Estonia' },
  { value: 'eswatini', label: 'Eswatini' },
  { value: 'ethiopia', label: 'Ethiopia' },
  { value: 'fiji', label: 'Fiji' },
  { value: 'finland', label: 'Finland' },
  { value: 'france', label: 'France' },
  { value: 'gabon', label: 'Gabon' },
  { value: 'gambia', label: 'Gambia' },
  { value: 'georgia', label: 'Georgia' },
  { value: 'germany', label: 'Germany' },
  { value: 'ghana', label: 'Ghana' },
  { value: 'greece', label: 'Greece' },
  { value: 'grenada', label: 'Grenada' },
  { value: 'guatemala', label: 'Guatemala' },
  { value: 'guinea', label: 'Guinea' },
  { value: 'guinea-bissau', label: 'Guinea-Bissau' },
  { value: 'guyana', label: 'Guyana' },
  { value: 'haiti', label: 'Haiti' },
  { value: 'honduras', label: 'Honduras' },
  { value: 'hungary', label: 'Hungary' },
  { value: 'iceland', label: 'Iceland' },
  { value: 'india', label: 'India' },
  { value: 'indonesia', label: 'Indonesia' },
  { value: 'iran', label: 'Iran' },
  { value: 'iraq', label: 'Iraq' },
  { value: 'ireland', label: 'Ireland' },
  { value: 'israel', label: 'Israel' },
  { value: 'italy', label: 'Italy' },
  { value: 'jamaica', label: 'Jamaica' },
  { value: 'japan', label: 'Japan' },
  { value: 'jordan', label: 'Jordan' },
  { value: 'kazakhstan', label: 'Kazakhstan' },
  { value: 'kenya', label: 'Kenya' },
  { value: 'kiribati', label: 'Kiribati' },
  { value: 'kuwait', label: 'Kuwait' },
  { value: 'kyrgyzstan', label: 'Kyrgyzstan' },
  { value: 'laos', label: 'Laos' },
  { value: 'latvia', label: 'Latvia' },
  { value: 'lebanon', label: 'Lebanon' },
  { value: 'lesotho', label: 'Lesotho' },
  { value: 'liberia', label: 'Liberia' },
  { value: 'libya', label: 'Libya' },
  { value: 'liechtenstein', label: 'Liechtenstein' },
  { value: 'lithuania', label: 'Lithuania' },
  { value: 'luxembourg', label: 'Luxembourg' },
  { value: 'madagascar', label: 'Madagascar' },
  { value: 'malawi', label: 'Malawi' },
  { value: 'malaysia', label: 'Malaysia' },
  { value: 'maldives', label: 'Maldives' },
  { value: 'mali', label: 'Mali' },
  { value: 'malta', label: 'Malta' },
  { value: 'marshall-islands', label: 'Marshall Islands' },
  { value: 'mauritania', label: 'Mauritania' },
  { value: 'mauritius', label: 'Mauritius' },
  { value: 'mexico', label: 'Mexico' },
  { value: 'micronesia', label: 'Micronesia' },
  { value: 'moldova', label: 'Moldova' },
  { value: 'monaco', label: 'Monaco' },
  { value: 'mongolia', label: 'Mongolia' },
  { value: 'montenegro', label: 'Montenegro' },
  { value: 'morocco', label: 'Morocco' },
  { value: 'mozambique', label: 'Mozambique' },
  { value: 'myanmar', label: 'Myanmar' },
  { value: 'namibia', label: 'Namibia' },
  { value: 'nauru', label: 'Nauru' },
  { value: 'nepal', label: 'Nepal' },
  { value: 'netherlands', label: 'Netherlands' },
  { value: 'new-zealand', label: 'New Zealand' },
  { value: 'nicaragua', label: 'Nicaragua' },
  { value: 'niger', label: 'Niger' },
  { value: 'nigeria', label: 'Nigeria' },
  { value: 'north-korea', label: 'North Korea' },
  { value: 'north-macedonia', label: 'North Macedonia' },
  { value: 'norway', label: 'Norway' },
  { value: 'oman', label: 'Oman' },
  { value: 'pakistan', label: 'Pakistan' },
  { value: 'palau', label: 'Palau' },
  { value: 'panama', label: 'Panama' },
  { value: 'papua-new-guinea', label: 'Papua New Guinea' },
  { value: 'paraguay', label: 'Paraguay' },
  { value: 'peru', label: 'Peru' },
  { value: 'philippines', label: 'Philippines' },
  { value: 'poland', label: 'Poland' },
  { value: 'portugal', label: 'Portugal' },
  { value: 'qatar', label: 'Qatar' },
  { value: 'romania', label: 'Romania' },
  { value: 'russia', label: 'Russia' },
  { value: 'rwanda', label: 'Rwanda' },
  { value: 'saint-kitts-and-nevis', label: 'Saint Kitts and Nevis' },
  { value: 'saint-lucia', label: 'Saint Lucia' },
  { value: 'saint-vincent-and-grenadines', label: 'Saint Vincent and Grenadines' },
  { value: 'samoa', label: 'Samoa' },
  { value: 'san-marino', label: 'San Marino' },
  { value: 'sao-tome-and-principe', label: 'Sao Tome and Principe' },
  { value: 'saudi-arabia', label: 'Saudi Arabia' },
  { value: 'senegal', label: 'Senegal' },
  { value: 'serbia', label: 'Serbia' },
  { value: 'seychelles', label: 'Seychelles' },
  { value: 'sierra-leone', label: 'Sierra Leone' },
  { value: 'singapore', label: 'Singapore' },
  { value: 'slovakia', label: 'Slovakia' },
  { value: 'slovenia', label: 'Slovenia' },
  { value: 'solomon-islands', label: 'Solomon Islands' },
  { value: 'somalia', label: 'Somalia' },
  { value: 'south-africa', label: 'South Africa' },
  { value: 'south-korea', label: 'South Korea' },
  { value: 'south-sudan', label: 'South Sudan' },
  { value: 'spain', label: 'Spain' },
  { value: 'sri-lanka', label: 'Sri Lanka' },
  { value: 'sudan', label: 'Sudan' },
  { value: 'suriname', label: 'Suriname' },
  { value: 'sweden', label: 'Sweden' },
  { value: 'switzerland', label: 'Switzerland' },
  { value: 'syria', label: 'Syria' },
  { value: 'taiwan', label: 'Taiwan' },
  { value: 'tajikistan', label: 'Tajikistan' },
  { value: 'tanzania', label: 'Tanzania' },
  { value: 'thailand', label: 'Thailand' },
  { value: 'timor-leste', label: 'Timor-Leste' },
  { value: 'togo', label: 'Togo' },
  { value: 'tonga', label: 'Tonga' },
  { value: 'trinidad-and-tobago', label: 'Trinidad and Tobago' },
  { value: 'tunisia', label: 'Tunisia' },
  { value: 'turkey', label: 'Turkey' },
  { value: 'turkmenistan', label: 'Turkmenistan' },
  { value: 'tuvalu', label: 'Tuvalu' },
  { value: 'uganda', label: 'Uganda' },
  { value: 'ukraine', label: 'Ukraine' },
  { value: 'united-arab-emirates', label: 'United Arab Emirates' },
  { value: 'united-kingdom', label: 'United Kingdom' },
  { value: 'usa', label: 'United States' },
  { value: 'uruguay', label: 'Uruguay' },
  { value: 'uzbekistan', label: 'Uzbekistan' },
  { value: 'vanuatu', label: 'Vanuatu' },
  { value: 'vatican-city', label: 'Vatican City' },
  { value: 'venezuela', label: 'Venezuela' },
  { value: 'vietnam', label: 'Vietnam' },
  { value: 'yemen', label: 'Yemen' },
  { value: 'zambia', label: 'Zambia' },
  { value: 'zimbabwe', label: 'Zimbabwe' },
];
const getStatesByCountry = (country) => {
  switch (country) {
    case 'brazil':
      return [
        { value: 'ac', label: 'Acre' },
        { value: 'al', label: 'Alagoas' },
        { value: 'ap', label: 'Amapá' },
        { value: 'am', label: 'Amazonas' },
        { value: 'ba', label: 'Bahia' },
        { value: 'ce', label: 'Ceará' },
        { value: 'df', label: 'Distrito Federal' },
        { value: 'es', label: 'Espírito Santo' },
        { value: 'go', label: 'Goiás' },
        { value: 'ma', label: 'Maranhão' },
        { value: 'mt', label: 'Mato Grosso' },
        { value: 'ms', label: 'Mato Grosso do Sul' },
        { value: 'mg', label: 'Minas Gerais' },
        { value: 'pa', label: 'Pará' },
        { value: 'pb', label: 'Paraíba' },
        { value: 'pr', label: 'Paraná' },
        { value: 'pe', label: 'Pernambuco' },
        { value: 'pi', label: 'Piauí' },
        { value: 'rj', label: 'Rio de Janeiro' },
        { value: 'rn', label: 'Rio Grande do Norte' },
        { value: 'rs', label: 'Rio Grande do Sul' },
        { value: 'ro', label: 'Rondônia' },
        { value: 'rr', label: 'Roraima' },
        { value: 'sc', label: 'Santa Catarina' },
        { value: 'sp', label: 'São Paulo' },
        { value: 'se', label: 'Sergipe' },
        { value: 'to', label: 'Tocantins' },
      ];
    case 'usa':
      return [
        { value: 'al', label: 'Alabama' },
        { value: 'ak', label: 'Alaska' },
        { value: 'az', label: 'Arizona' },
        { value: 'ar', label: 'Arkansas' },
        { value: 'ca', label: 'California' },
        { value: 'co', label: 'Colorado' },
        { value: 'ct', label: 'Connecticut' },
        { value: 'de', label: 'Delaware' },
        { value: 'fl', label: 'Florida' },
        { value: 'ga', label: 'Georgia' },
        { value: 'hi', label: 'Hawaii' },
        { value: 'id', label: 'Idaho' },
        { value: 'il', label: 'Illinois' },
        { value: 'in', label: 'Indiana' },
        { value: 'ia', label: 'Iowa' },
        { value: 'ks', label: 'Kansas' },
        { value: 'ky', label: 'Kentucky' },
        { value: 'la', label: 'Louisiana' },
        { value: 'me', label: 'Maine' },
        { value: 'md', label: 'Maryland' },
        { value: 'ma', label: 'Massachusetts' },
        { value: 'mi', label: 'Michigan' },
        { value: 'mn', label: 'Minnesota' },
        { value: 'ms', label: 'Mississippi' },
        { value: 'mo', label: 'Missouri' },
        { value: 'mt', label: 'Montana' },
        { value: 'ne', label: 'Nebraska' },
        { value: 'nv', label: 'Nevada' },
        { value: 'nh', label: 'New Hampshire' },
        { value: 'nj', label: 'New Jersey' },
        { value: 'nm', label: 'New Mexico' },
        { value: 'ny', label: 'New York' },
        { value: 'nc', label: 'North Carolina' },
        { value: 'nd', label: 'North Dakota' },
        { value: 'oh', label: 'Ohio' },
        { value: 'ok', label: 'Oklahoma' },
        { value: 'or', label: 'Oregon' },
        { value: 'pa', label: 'Pennsylvania' },
        { value: 'ri', label: 'Rhode Island' },
        { value: 'sc', label: 'South Carolina' },
        { value: 'sd', label: 'South Dakota' },
        { value: 'tn', label: 'Tennessee' },
        { value: 'tx', label: 'Texas' },
        { value: 'ut', label: 'Utah' },
        { value: 'vt', label: 'Vermont' },
        { value: 'va', label: 'Virginia' },
        { value: 'wa', label: 'Washington' },
        { value: 'wv', label: 'West Virginia' },
        { value: 'wi', label: 'Wisconsin' },
        { value: 'wy', label: 'Wyoming' },
      ];
    default:
      return [];
  }
};

export interface EditLocationModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (data: { country: string; state: string; city: string }) => Promise<void>;
  initialData: { country: string; state: string; city: string };
}

export const EditLocationModal: React.FC<EditLocationModalProps> = ({ open, onClose, onSave, initialData }) => {
  const { t } = useI18n();
  const [country, setCountry] = useState(initialData.country || '');
  const [state, setState] = useState(initialData.state || '');
  const [city, setCity] = useState(initialData.city || '');
  const [openCountry, setOpenCountry] = useState(false);
  const [openState, setOpenState] = useState(false);
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    // Find the country in the array by value (case-insensitive)
    const normalizedCountry = (initialData.country || '').toLowerCase();
    const matchedCountry = countries.find(c => c.value.toLowerCase() === normalizedCountry)?.value || '';
    // Find the state in the array by value (case-insensitive)
    const normalizedState = (initialData.state || '').toLowerCase();
    const matchedState = getStatesByCountry(matchedCountry).find(s => s.value.toLowerCase() === normalizedState)?.value || '';
    setCountry(matchedCountry);
    setState(matchedState);
    // If Brazil/USA, populate city, otherwise clear
    if (matchedCountry === 'brazil' || matchedCountry === 'usa') {
      setCity(initialData.city || '');
    } else {
      setCity('');
    }
  }, [initialData, open]);

  // When the country changes, reset state/city if necessary
  useEffect(() => {
    if (country === 'brazil' || country === 'usa') {
      // Keep state/city
    } else {
      setState('');
      setCity('');
    }
  }, [country]);

  const showStateCity = country === 'brazil' || country === 'usa';

  const validate = () => {
    const errs: { [key: string]: string } = {};
    if (!country) errs.country = t('profile.country_required');
    if (showStateCity && !state) errs.state = t('profile.state_required');
    if (showStateCity && !city.trim()) errs.city = t('profile.city_required');
    return errs;
  };

  const handleSave = async () => {
    const errs = validate();
    setErrors(errs);
    if (Object.keys(errs).length > 0) return;
    setSaving(true);
    try {
      await onSave({ country, state: showStateCity ? state : '', city: showStateCity ? city : '' });
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="w-[90vw] max-w-xl bg-white rounded-2xl">
        <DialogHeader>
          <DialogTitle className="text-black font-sans">{t('profile.edit_location')}</DialogTitle>
          <DialogDescription className="text-gray-600 text-sm">
            {t('profile.edit_location_description')}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1 text-black">{t('profile.country')}</label>
            <div className="w-full border border-black rounded-md relative">
              <Select value={country} onValueChange={v => { setCountry(v); setState(''); setCity(''); }} open={openCountry} onOpenChange={setOpenCountry}>
                <SelectTrigger className="w-full border-0 text-black bg-white relative rounded-md shadow-none focus:ring-0 focus:outline-none">
                  <SelectValue placeholder={t('profile.select_country')} />
                  {openCountry ? <ChevronUp className="absolute right-3 top-1/2 -translate-y-1/2 text-black" /> : <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-black" />}
                </SelectTrigger>
                <SelectContent className="bg-white border-black">
                  {countries.map(c => (
                    <SelectItem key={c.value} value={c.value} className="text-black">{c.label}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            {errors.country && <p className="text-xs text-red-600 mt-1">{errors.country}</p>}
          </div>
          {showStateCity && (
            <div>
              <label className="block text-sm font-medium mb-1 text-black">{t('profile.state')}</label>
              <div className="w-full border border-black rounded-md relative">
                <Select value={state} onValueChange={setState} open={openState} onOpenChange={setOpenState}>
                  <SelectTrigger className="w-full border-0 text-black bg-white relative rounded-md shadow-none focus:ring-0 focus:outline-none">
                    <SelectValue placeholder={t('profile.select_state')} />
                    {openState ? <ChevronUp className="absolute right-3 top-1/2 -translate-y-1/2 text-black" /> : <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-black" />}
                  </SelectTrigger>
                  <SelectContent className="bg-white border-black">
                    {getStatesByCountry(country).map(s => (
                      <SelectItem key={s.value} value={s.value} className="text-black">{s.label}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              {errors.state && <p className="text-xs text-red-600 mt-1">{errors.state}</p>}
            </div>
          )}
          {showStateCity && state && (
            <div>
              <label className="block text-sm font-medium mb-1 text-black">{t('profile.city')}</label>
              <Input value={city} onChange={e => setCity(e.target.value)} className="text-black border-black bg-white" />
              {errors.city && <p className="text-xs text-red-600 mt-1">{errors.city}</p>}
            </div>
          )}
        </div>
        <Button
          className="w-full bg-[#D72E16] hover:bg-[#B8251A] text-white font-medium py-3 h-11 rounded-full transition-colors duration-200 disabled:opacity-50 mt-6"
          onClick={handleSave}
          disabled={saving || Object.keys(validate()).length > 0}
        >
          {saving ? t('profile.saving') : t('common.save')}
        </Button>
      </DialogContent>
    </Dialog>
  );
}; 